import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { zootDocDecisionColor } from "features/quote/constants";
import { useQueryWithErrorHandling } from "hooks/errorHandling";
import { GET_ZOOT_DOCUMENT_DECISION_INFO_QUERY } from "../queries";
import useUserData from "hooks/useUserData";
import { LoadingFakeText } from "@totalsoft/rocket-webapp-components-deprecated";

function QuoteDecisionContent({ dialogState }) {
  const { t } = useTranslation();
  const { showDecisionReasons } = useUserData();

  const { data, loading } = useQueryWithErrorHandling(GET_ZOOT_DOCUMENT_DECISION_INFO_QUERY, {
    variables: { quoteId: dialogState.quoteId },
  });
  const docDecision = data?.quote;

  if (loading) return <LoadingFakeText lines={2} />;

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography>
          {!docDecision.zootDocDecisionFinished ||
          (docDecision.zootDocDecisionColor != zootDocDecisionColor.green &&
            docDecision.zootDocDecisionColor != zootDocDecisionColor.red)
            ? t("Quote.ZootNoDecision")
            : docDecision.folderId
            ? t("Quote.ZootFinalDecision")
            : t("Quote.ZootIndicativeDecision")}
        </Typography>
      </Grid>
      {showDecisionReasons && docDecision.zootDocDecisionFinished && (
        <Grid item xs={12}>
          <Typography>
            {t("Quote.Reasons", {
              reason: docDecision.zootDocDecisionReasons ? docDecision.zootDocDecisionReasons : "-",
            })}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
}

QuoteDecisionContent.propTypes = {
  dialogState: PropTypes.object.isRequired,
};

export default QuoteDecisionContent;
